import Handler from "@/core/domain/usecase/handler";

const changeServiceOrderReportImageRepository = (axios) => async (link, image) => {
    try {
        //clean axios header because minio already have
        const cleanAxios = axios.create({
            headers: {}
        })
        
        const response = await cleanAxios.put(`${link}`, image)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default changeServiceOrderReportImageRepository